import { checkSvg } from "../svg/check.svg";
import { closeSvg } from "../svg/close.svg";
import React from "react";

export const booleanFormatter = (value) => {
  let result;
  if (value) {
    result = <div className="check-svg">{checkSvg()}</div>;
  } else {
    result = <div className="close-svg">{closeSvg()}</div>;
  }
  return result;
};
